import { render, staticRenderFns } from "./AvatarUsuario.vue?vue&type=template&id=3ff0ef92&scoped=true&lang=pug&"
import script from "./AvatarUsuario.vue?vue&type=script&lang=js&"
export * from "./AvatarUsuario.vue?vue&type=script&lang=js&"
import style0 from "./AvatarUsuario.vue?vue&type=style&index=0&id=3ff0ef92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff0ef92",
  null
  
)

export default component.exports